import React, { useState, useEffect } from 'react';
import { Col } from 'reactstrap';
import { CountUp } from '@core/frontend/shared';
import Cookies from 'js-cookie';
import classes from '../Countdown/Countdown.module.scss';

const FundingPoolCounter = ({ balance = 0 }) => {
    const [animate, setAnimate] = useState(false);
    const animateMessage = 'Jetzt mit SMS-Code abstimmen!';

    useEffect(() => {
        if (Cookies.get('bigfoot_code-requested') && !animate) {
            setAnimate(true);
        } else if (!Cookies.get('bigfoot_code-requested') && animate) {
            setAnimate(false);
        }
    }, [animate]);

    const balanceString = balance.toLocaleString('de-DE', { maximumFractionDigits: 2 });
    const formattedMessage = `Es sind noch ${balanceString} € im Fördertopf`;

    return (
        <Col className={`bg-primary px-0 py-1 text-center ${animate ? classes.CountdownWrapper : ''}`}>
            <p
                className={`mb-0 ${animate ? classes.animatedElement + ' ' + classes.CountdownTimer : ''}`}
                aria-hidden={true}
            >
                Es sind noch <CountUp start={0} end={balance} duration={2} separator="." delay={2} /> € im Fördertopf
            </p>
            {animate && (
                <p className={`mb-0 py-1 ${classes.animatedElement} ${classes.CountDownMessage}`} aria-hidden={true}>
                    {animateMessage}
                </p>
            )}
            <p className="visually-hidden">{formattedMessage}</p>
        </Col>
    );
};

export default FundingPoolCounter;
